import { skillGroups } from "../data/skillsData";
import "../styles/skillsSection.css";

// Relative luminance (0 = black, 1 = white) of a "#rrggbb" color.
const luminance = (hex) => {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
};

// Icon colors for a skill. Near-black brand colors (Express, Pandas, Kafka)
// would vanish on the dark background, so dark mode falls back to the
// heading color for those.
const brandVars = (skill) => {
  const color = skill.brand ? `#${skill.brand.hex}` : skill.color;
  return {
    "--brand": color,
    "--brand-dark":
      luminance(color) < 0.08 ? "var(--heading-color)" : color,
  };
};

const SkillIcon = ({ skill }) =>
  skill.brand ? (
    <svg
      className="skill-icon"
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path d={skill.brand.path} />
    </svg>
  ) : (
    <i className={`skill-icon ${skill.fa}`} aria-hidden="true"></i>
  );

const SkillsSection = () => {
  return (
    <section id="skills" className="skills-section">
      <h2 className="reveal">Skills</h2>
      <div className="skill-cards-container">
        {skillGroups.map((group) => (
          <div key={group.id} className="skill-card reveal">
            <div className="skill-card-header">
              <div className="icon-wrapper">
                <i className={group.icon} aria-hidden="true"></i>
                <h3>{group.title}</h3>
              </div>
              <p>{group.description}</p>
            </div>
            <ul className="skill-chips">
              {group.skills.map((skill) => (
                <li
                  key={skill.name}
                  className="skill-chip"
                  style={brandVars(skill)}
                >
                  <SkillIcon skill={skill} />
                  <span>{skill.name}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default SkillsSection;
